const verifyUrl = (url: string) => {
  const res = url.match(/^(http(s)?:\/\/.)/);
  return res !== null;
};

export const validEmbedCode = (code: string) => {
  if (code.includes("iframe") || verifyUrl(code)) {
    return true;
  }
  return false;
};

export const embedCodeType = (code: string) => {
  if (verifyUrl(code)) {
    return "url";
  } else if (code.includes("iframe")) {
    return "iframe";
  } else {
    return "other";
  }
};

export const getIframeSrcDom = (htmlSnippet: string) => {
  const template = document.createElement("template");
  template.innerHTML = htmlSnippet.trim();
  const iframe = template.content.querySelector("iframe");
  return iframe ? iframe.src : null;
};
